import { mapGetters } from "vuex";
export const mixins = {
  data() {
    return {
      category: "",
      categoryName: {
        1: "通知公告",
        2: "行业动态",
        zyk: "资源库",
        overseasEducation: "海外办学",
        internationalExchange: "国际交流",
        personnelTraining: "人才培养",
        childbirthEducation: "产教融合",
        schoolEnterprise: "校企合作",
        studyAbroad: "留学服务",
        demandInformation: "需求信息",
        unit: "共建单位",
        serviceOrganization: "服务组织",
        zcwj: "政策文件",
        xmxx: "项目信息",
      },
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {
    if (this.$route.query.category) this.category = this.$route.query.category;
  },
  methods: {
    getDic(code, { key, callback }) {
      let that = this;
    },
  },
};
